const withPrefix = (prefix: string, value: string): string => {
    return prefix + value;
};

export default withPrefix;
